import { types, actions } from './requests'
export const GETSWA300DATA_TYPES = {
    ...types('GETSWA300DATA'),
}
export const GETSWA300DATA_ACTIONS = {
    ...actions('GETSWA300DATA'),
}
